<template>
  <div>
    <router-view />
  </div>
</template>
<script>
import BreadcrumbHeader from "../components/template/_template-breadcrumb-header";

export default {
  name: "OpinionSurvey",
  components: { BreadcrumbHeader },
};
</script>

<style lang="sass">
/*  containers/OpionionSurvey */

@import "../assets/css/variables.scss"

.filters
  text-align: center
  legend
    font-size: 0.9rem
    margin: 0
    line-height: 0.9rem
    height: 2rem
    p
      margin: 0px
  input, .custom-select
    border-radius: 10px
    border: 1px solid #000
  [type="date"]
    background: #fff url('/static/icons/calendar_icon.svg')  97% 50% no-repeat
    background-size: 2rem
    padding: 0.375rem 0.4rem
    color: #c2c2c2
    font-family: $font-subtitle-light
  [type="date"]::-webkit-inner-spin-button
    display: none
  [type="date"]::-webkit-calendar-picker-indicator
    opacity: 0

.invitations-table
  text-align: center
  thead
    background-color: #000
    color: #fff
  th, td
    padding: 5px 15px
  .btn
    padding: 0px
    .fa-icon
      color: $accent-color

.table-bordered th, .table-bordered td
    border-right: 1px solid #575454
    border-left: 1px solid #575454

.table-striped tbody tr:nth-of-type(odd)
    background-color: #d1d3d4

.modal
  text-align: center
  .modal-title
    width: 100%
  .modal-footer
    justify-content: center
</style>
